/**
 * Encaptulates functionality to store and retrieve FRP data from the data store
 */
import { ESInterface } from "src/compentsModus/ESInterface";
import { VersionedObjectPersistence } from "src/common/managers/ESVersionedPersistance";
import { FRPProject, FRPProjectPersistenceInterface } from "./FRPState";

export class FRPProjectPersistence extends VersionedObjectPersistence<FRPProject> implements FRPProjectPersistenceInterface {

   static instance: FRPProjectPersistence;

   static setInstance(instance: FRPProjectPersistence) {
      FRPProjectPersistence.instance = instance;
   }

   static getInstance(): FRPProjectPersistence {
      if (!FRPProjectPersistence.instance) {
         throw new Error("FRPProjectPersistence not initialized");
      }
      return FRPProjectPersistence.instance;
   }

   public static indexMappings =
      {
         "properties": {
            "geopoint": {
               "type": "geo_point"
            },
            "geoshape": {
               "type": "geo_shape"
            },
            "point": {
               "type": "geo_point"
            },
            "geometry": {
               "type": "geo_shape"
            },
            "viamapUserId": {
               "type": "keyword"
            },
            "lastChangedTimestamp": {
               "type": "date"
            },
            "expectedStartDate": {
               "type": "date"
            },
            "expectedEndDate": {
               "type": "date"
            }
            // Other fields are dynamic and assigned a type automatically by ES
         }
      }
   private static idGetter = (object) => { return object.id; }

   constructor(objectsESIndexName: string, userId: string) {

      super(objectsESIndexName, userId, {}, FRPProjectPersistence.idGetter)

   }

   async createProject(project: FRPProject): Promise<void> {
      const existingDoc = await this.es.getDocument(project.id);
      if (existingDoc?.found) {
         throw new Error(`Project '${project.id}' already exists`);
      }

      const elementEs = new ESInterface(project.esIndexName);
      if (await elementEs.indexExists(project.esIndexName)) {
         throw new Error(`Project index '${project.esIndexName}' already exists`);
      }

      const indexOptions = {
         mappings: {
            ...FRPProjectPersistence.indexMappings,
            "_meta": { "CreatedBy": this.userId }
         }
      };

      await this.saveObject(project);
      try {
         await elementEs.createIndex(project.esIndexName, indexOptions);
      } catch (error) {
         await this.deleteObject(project.id).catch(() => { });
         throw error;
      }
   }

}

